import { render, staticRenderFns } from "./BaseElem.vue?vue&type=template&id=6a40b080&"
import script from "./BaseElem.vue?vue&type=script&lang=js&"
export * from "./BaseElem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports